var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoleIconSmall = function SvgRoleIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.364 2.126h2.845c.435 0 .791.365.791.81v5.252a.804.804 0 0 1-.79.812H1.79A.803.803 0 0 1 1 8.188V2.937c0-.447.356-.811.791-.811h2.845C4.636 1.504 5.14 1 5.762 1h.476c.622 0 1.126.504 1.126 1.126zM6.03 4.136c.394 0 .713-.32.713-.714V2.64a.713.713 0 0 0-1.426 0v.783c0 .394.32.713.713.713z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoleIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role-icon-small.aefd155eacb31b837942e4853ce6c00b.svg";